"use strict";
/* eslint-disable quotes */
const en = require('./en');
const intl = require('@lemonone/intl/lib/es');
module.exports = Object.assign({}, en, intl, {
    '@lemonone/components/Uploader:reupload': 'Subir de nuevo'
});
//# sourceMappingURL=es.js.map